<template>
  <div class="tr-step-3">
    <!-- <div class="step3A__highlight-card">
      <div class="highlight-header">HIGHLIGHTS</div>
      <div class="hightlight__content-container">
        <div class="highlight-table3A-label-col">
          <span class="label">Orientation</span>
          <span class="label">% Wall Surface Area</span>
          <span class="label">Wall Surface Area</span>
        </div>
        <div class="highlight-table3A-col" v-for="(orient, orientationIndex) in step3A.wallSurfaceAreaArrObj" :key="orient.wallOrientation">
          <span class="heading"> {{ orient.wallOrientation }}</span>
          <span class="input">{{ orient.orientationSurfaceArea }} </span>
          <span class="value">{{ orient.calcWallArea.toFixed(2) }}</span>
        </div>
      </div>
    </div> -->
    <div class="step3B__highlight-card">
      <div class="highlight-header">HIGHLIGHTS</div>
      <Highlight3A />
    </div>
    <div class="tr-step-3__card">
      <div class="tr-step-3A__mainHead">STEP:3 Openable Area Details</div>
      <div class="tr-step-3A__subHead">(A) Wall Surface Area</div>

      <div>
        <v-expansion-panels focusable>
          <v-expansion-panel v-for="(item, i) in 1" :key="i" :style="{ margin: '4px' }">
            <v-expansion-panel-header>
              <div class="accordian__header--3A">
                <v-icon left>mdi-wall</v-icon>
                Wall Surface Area
              </div>
            </v-expansion-panel-header>
            <v-expansion-panel-content>
              <div class="step-2__accordian-fields-wrap">
                <div class="step-2__accordian-fields-row">
                  <!--Wall Surface Area Table -->
                  <WallSurfaceAreaTable @calculateTotal="totalWallSurfaceArea" />
                  <!-- <data-table-vuetify /> -->
                </div>
              </div>
            </v-expansion-panel-content>
          </v-expansion-panel>
        </v-expansion-panels>
      </div>

      <div class="step-3A__summary">
        <div class="summary-head">Summary:</div>
        <div class="summary-block__wrap">
          <div>
            <v-alert v-if="step3A.summary.total_wall_percent !== 100" style="width:100%" text dense type="error">
              <div class="summary-field__row">
                <div class="sumarry-field__label">
                  Summation of input percentage :
                </div>

                <div class="summary-field__value">{{ step3A.summary.total_wall_percent }} %</div>
              </div>
            </v-alert>
            <v-alert v-else-if="step3A.summary.total_wall_percent == 100" text dense style="width:100%" type="success">
              <div class="summary-field__row">
                <div class="sumarry-field__label">
                  Summation of input percentage :
                </div>
                <div class="summary-field__value">{{ step3A.summary.total_wall_percent }} %</div>
              </div>
            </v-alert>
          </div>
          <div class="summary-field__row">
            <div class="sumarry-field__label">Total wall surface area <span class="units">(sq.M):</span></div>

            <div class="summary-field__value">{{ step3A.summary.total_wall_surface_area }} <span class="units"></span></div>
          </div>
        </div>
      </div>
      <div class="step-3A__next-back-row">
        <v-btn color="blue-grey" class="ma-2 white--text" @click="$router.push({ name: 'Step2' })"><v-icon left> mdi-arrow-left </v-icon> Back </v-btn>
        <v-btn color="blue-grey" class="ma-2 white--text" :disabled="step3A.summary.total_wall_percent !== 100" @click="checkTotalWallAreaPercent">Next <v-icon right> mdi-arrow-right </v-icon> </v-btn>
      </div>
    </div>
  </div>
</template>

<script>
import WallSurfaceAreaTable from '../tables/step3A/WallSurfaceAreaTable.vue';
// import DataTableVuetify from '../DataTableVuetify.vue';
import Highlight3A from '../highlights/Highlight3A.vue';
export default {
  components: {
    WallSurfaceAreaTable,
    // DataTableVuetify,
    Highlight3A,
  },
  data() {
    return {
      // totalWallPercent: 0,
    };
  },
  computed: {
    schema: {
      get: function() {
        return this.$store.state.schema;
      },
      set: function(newSchema) {
        this.$store.dispatch('setSchema', newSchema);
      },
    },
    step2: {
      get: function() {
        return this.$store.state.schema.inputs.step2;
      },
      set: function(step2) {
        this.$store.dispatch('setStep2', step2);
      },
    },
    step3A: {
      get: function() {
        return this.$store.state.schema.inputs.step3A;
      },
      set: function(step3A) {
        this.$store.dispatch('setStep3A', step3A);
      },
    },
    // computetotalWallPercent() {
    //   this.totalWallPercent = 0;
    //   for (let i = 0; i <= this.step3A.wallSurfaceAreaArrObj.length - 1; i++) {
    //     this.totalWallPercent = +this.totalWallPercent + +this.step3A.wallSurfaceAreaArrObj[i].orientationSurfaceArea;
    //   }
    //   return this.totalWallPercent;
    // },
  },
  beforeUpdate() {
    // this.computetotalWallPercent();
    // this.totalWallSurfaceArea();
  },
  // watch: {
  //   computetotalWallPercent: function() {
  //     this.totalWallSurfaceArea();
  //   },
  // },
  methods: {
    checkTotalWallAreaPercent() {
      if (this.step3A.summary.total_wall_percent === 100) {
        this.$router.push({ name: 'Step3B' });
      }
    },
    totalWallSurfaceArea(tp) {
      let sumWallArea = 0;
      // this.totalWallPercent = tp;
      this.step3A.summary.total_wall_percent = tp;
      for (let i = 0; i <= this.step3A.wallSurfaceAreaArrObj.length - 1; i++) {
        //checking total wall percent =100%
        // this.totalWallPercent = +this.totalWallPercent + +this.step3A.wallSurfaceAreaArrObj[i].orientationSurfaceArea;
        //total wall surface area
        sumWallArea = Number(+sumWallArea + +this.step3A.wallSurfaceAreaArrObj[i].calcWallArea);
      }

      this.step3A.summary.total_wall_surface_area = +sumWallArea.toFixed(2);
      console.log('Total wall surface area 3A', this.step3A.summary.total_wall_surface_area);
    },
  },
};
</script>

<style lang="scss" scoped>
.tr-step-3 {
  padding: 32px;
  width: 100%;
  height: 100%;
}
.step3B__highlight-card {
  background-color: #fff;
  margin: 24px 0px;
  // padding: 38px;
  .highlight-header {
    background-color: #5a6978;

    padding: 8px 24px;
    color: #fff;
    font-size: 20px;
  }
}
// .step3A__highlight-card {
//   background-color: #fff;
//   margin-bottom: 24px;
//   // padding: 38px;
//   .highlight-header {
//     background-color: #5a6978;

//     padding: 8px 24px;
//     color: #fff;
//     font-size: 20px;
//   }
// }

// .hightlight__content-container {
//   display: flex;
//   // justify-content: space-evenly;
// }
// .highlight-table3A-col {
//   display: flex;
//   flex-direction: column;
//   justify-content: center;
//   align-items: center;
//   border-right: 1px solid #a4abb3;
//   width: 72px;

//   .heading,
//   .input,
//   .value {
//     text-align: center;
//     border-bottom: 1px solid #a4abb3;
//     width: 100%;
//   }
//   .heading {
//     background-color: #dedede;
//   }
//   .input {
//     background-color: #c4def5;
//   }
// }
// .highlight-table3A-label-col {
//   display: flex;
//   flex-direction: column;
//   justify-content: center;
//   align-items: center;
//   border-right: 1px solid #a4abb3;
//   width: 220px;
//   .label {
//     text-align: center;
//     border-bottom: 1px solid #a4abb3;
//     width: 100%;
//     // font-size: 13px;
//     height: 25px;
//     background-color: #dedede;
//   }
// }
.tr-step-3__card {
  background-color: #fff;
  padding: 38px;
  // width: 80%;
}
.tr-step-3A__mainHead {
  margin: 0px 0px 8px 0;
  font-size: 28px;
  color: #343f4b;
  text-align: center;
}
.tr-step-3A__subHead {
  margin: 0px 0px 18px 0;
  font-size: 20px;
  color: #343f4b;
  text-align: center;
}

.accordian__header--3A {
  display: flex;
  justify-content: flex-start;
  align-items: center;
}

.step-3A__summary {
  margin-top: 12px;
  .summary-head {
    font-size: 18px;
    color: #343f4b;
    font-weight: 800;
  }
}
.summary-block__wrap {
  display: flex;
  flex-direction: column;
  .summary-field__row {
    display: flex;
    justify-content: space-between;
    &.--invalid {
      background-color: rgb(250, 167, 167);
    }
  }
  .summary-field__label {
    font-size: 12px;
    color: #343f4b;
  }
}
.step-3A__next-back-row {
  display: flex;
  justify-content: space-between;
}
</style>
